exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-annotation {\n  width: auto !important; }\n\n.annotation-title {\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 24px; }\n\n.annotationtype-container {\n  margin-left: 13px;\n  margin-top: 13px; }\n\n.stakeholder-name {\n  color: #A2A4A8;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/planning-poker-annotation-header/planning-poker-annotation-header.component.scss
// module id = ../../../../../src/app/components/planning-poker-annotation-header/planning-poker-annotation-header.component.scss
// module chunks = main